module.exports = __webpack_public_path__ + "static/media/gym_pt.278db846.png";